import { render, staticRenderFns } from "./LoaderBottom.vue?vue&type=template&id=8784e5a6&scoped=true"
import script from "./LoaderBottom.vue?vue&type=script&lang=js"
export * from "./LoaderBottom.vue?vue&type=script&lang=js"
import style0 from "./LoaderBottom.vue?vue&type=style&index=0&id=8784e5a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8784e5a6",
  null
  
)

export default component.exports